/* eslint-disable no-param-reassign */
import axios from 'axios';

class ServiceBase {
  constructor({ resource }) {
    this.resource = `${resource}/`;
    this.http = axios.create({
      baseURL: process.env.BASE_URL,
    });

    this.http.interceptors.request.use((config) => {
      const applicationId = process.env.APPLICATION_ID;
      if (applicationId) {
        config.headers.Application = `Bifrost ${applicationId}`;
      }
      return config;
    });
  }
}

export default ServiceBase;



// WEBPACK FOOTER //
// ./src/services/BasicServiceBase.js